import React, { useEffect, useState } from "react";
import "../../styles/styles.css";
import "../../styles/layout.css";

import { Button } from "@mui/material";
import {  Row, Col, } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import AttendanceVeiwController from "../../redux/actions/AttendenceApiAction";


const legendData = [
  { code: "P", label: "Present", className: "present" },
  { code: "A", label: "Absent", className: "absent" },
  { code: "O", label: "Off Day", className: "offday" },
  { code: "R", label: "Rest Day", className: "restday" },
  { code: "L", label: "Leave", className: "leave" },
  { code: "H", label: "Holiday", className: "holiday" },
  { code: "½", label: "Half Day", className: "halfday" },
  { code: "OD", label: "On Duty", className: "onduty" },
  { code: "D", label: "Deduction", className: "deduction" },
  { code: "?", label: "Status Unknown", className: "unknown" },
  { code: "OT", label: "Overtime", className: "overtime" },
  { code: "E", label: "Early Logout", className: "early" },
//   { code: "!", label: "Alert for Deduction", className: "alert-deduction" },
//   { code: "↺", label: "Override", className: "override" },
//   { code: "🚫", label: "Ignored", className: "ignored" },
//   { code: "▲", label: "Grace", className: "grace" },
//   { code: "▶", label: "Regularized", className: "regularized" },
 
];

const statusGradients = {
  A: "linear-gradient(135deg, #f8d7da 0%, #fbe9eb 100%)",   
  O: "linear-gradient(135deg, #f1f8e9 0%, #f3f9ec 100%)",   
  R: "linear-gradient(135deg, #e0f7fa 0%, #e9f9fb 100%)",   
  L: "linear-gradient(135deg, #e38582 0%, #f1c2c1 100%)",   
  E: "linear-gradient(135deg, #ffd699 0%, #ffebcc 100%)",
  P: "linear-gradient(135deg, #d4edda 0%, #dbf0e0 100%)",
  // default: "linear-gradient(135deg, #f0f0f0 0%, #d9d9d9 100%)" // default gray gradient
};


const TimeAttendance = () => {
  const userId = localStorage.getItem("user_id"); 
  const { getMonthlyAttendance} = AttendanceVeiwController();
  const {monthly_summary} = useSelector((state) => state.TimeAttendance);
  
  const dispatch = useDispatch();
  
  const today = new Date();
  const [selectedMonth, setSelectedMonth] = useState(today.getMonth() + 1); // month is 1-indexed for API
  const [selectedYear, setSelectedYear] = useState(today.getFullYear());
  const [selectedDate, setSelectedDate] = useState(new Date());
  const currentDate = new Date(selectedYear, selectedMonth - 1); // month is 0-indexed here
  useEffect(() => {
    dispatch(getMonthlyAttendance(userId, selectedYear, selectedMonth));
  }, [dispatch, userId, selectedMonth, selectedYear]);
  

  const formatTime = (dateStr) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr); // Handles +05:30
    const options = {
      timeZone: "Asia/Kolkata", // Use your local timezone
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    };
    return date.toLocaleString("en-GB", options);
  };

  
  const statusMap = {};

    if (monthly_summary?.attendance_records?.length) {
      monthly_summary.attendance_records.forEach((record) => {
        const date = record.date;
        statusMap[date] = {
          code: record.status,
          detail: record.holiday_details, // e.g., "Kamgar Din"
        };
        
      });
    }

  const getMonthName = (date) => {
    return date.toLocaleString("default", { month: "long", year: "numeric" });
  };

  const daysInMonth = (month, year) => new Date(year, month + 1, 0).getDate();

  const getFirstDayOfMonth = (month, year) => {
    return new Date(year, month, 1).getDay(); // Sunday = 0
  };

  const handlePrevMonth = () => {
    if (selectedMonth === 1) {
      setSelectedMonth(12);
      setSelectedYear((prev) => prev - 1);
    } else {
      setSelectedMonth((prev) => prev - 1);
    }
  };
  
  const handleNextMonth = () => {
    if (selectedMonth === 12) {
      setSelectedMonth(1);
      setSelectedYear((prev) => prev + 1);
    } else {
      setSelectedMonth((prev) => prev + 1);
    }
  };
  
  const isToday = (date) => {
    const today = new Date();
    return (
      today.getDate() === date 
    
    );
  };

  const attendanceRecord = monthly_summary?.attendance_records?.find(
    (record) => record.date === selectedDate.toLocaleDateString("en-CA")
  );

  const clockIn = attendanceRecord ? attendanceRecord.clock_in : null;
  const clockOut = attendanceRecord ? attendanceRecord.clock_out : null;
  const regularHours = attendanceRecord ? attendanceRecord.regular_hours : null;
  const overtimeHours = attendanceRecord ? attendanceRecord.overtime_hours: null;

  return (
    <>
    
    <div style={{ maxHeight: "100vh" }}>
      <div className="card d-flex d-flex-direction-row align-items-center">
        <div className="ms-3">
          <h3>Attendance Info</h3>
        </div>
      </div>
      <Row className="mt-2">
        <Col>
          <div className="card d-flex d-flex-direction-row align-items-center"
          style={{ background: 'linear-gradient(135deg, #a18cd1 , #fbc2eb )', padding: '16px', borderRadius: '8px',height: '100px',width: '100%' }}
           >
            <div className="d-flex d-flex-direction-column">
              <h6 style={{color: 'black', fontSize:"0.8125rem", fontFamily:'sans-serif'}} >
                AVG WORK HRS
              </h6>
              <h3 className="value m-0">{monthly_summary?.average_work_hours ?? "-"}</h3>
            </div>
          </div>
        </Col>
        <Col>
          <div className="card d-flex d-flex-direction-row align-items-center"
          style={{ background: 'linear-gradient(135deg, #007bff , #cce5ff )', padding: '16px', borderRadius: '8px', height: '100px',width: '100%'}}
          >
            <div className="d-flex d-flex-direction-column">
              <h6 style={{color: 'black', fontSize:"0.8125rem", fontFamily:'sans-serif'}}>ACTUAL WORK HRS</h6>
              <h3 className="value mb-0">{monthly_summary?.actual_work_hours ?? "-"}</h3>
            </div>
          </div>
        </Col>
        <Col>
          <div className="card d-flex d-flex-direction-row align-items-center" 
          style={{ background: 'linear-gradient(135deg, #357e46 , #d4edda )', padding: '16px', borderRadius: '8px',height: '100px',width: '100%' }}>
            <div className="d-flex d-flex-direction-column">
              <h6 style={{color: 'black', fontSize:"0.8125rem", fontFamily:'sans-serif'}} >PRESENT DAYS</h6>
              <h3 className="value mb-0">{monthly_summary?.present_days ?? "-"}</h3>
            </div>
          </div>
        </Col>
        <Col>
          <div className="card d-flex d-flex-direction-row align-items-center" 
          style={{ background: 'linear-gradient(135deg, #c32230 , #f8d7da )', padding: '16px', borderRadius: '8px',height: '100px',width: '100%' }}>
            <div className="d-flex d-flex-direction-column">
              <h6 style={{color: 'black', fontSize:"0.8125rem", fontFamily:'sans-serif'}} >ABSENT DAYS</h6>
              <h3 className="value mb-0">{monthly_summary?.absent_days?? "-"}</h3>
            </div>
          </div>
        </Col>
        <Col>
          <div className="card d-flex d-flex-direction-row align-items-center"
           style={{background: 'linear-gradient(135deg, #55585e , #e2e3e5 )', padding: '16px', borderRadius: '8px',height: '100px',width: '100%' }}>
            <div className="d-flex d-flex-direction-column">
              <h6 style={{color: 'black', fontSize:"0.8125rem", fontFamily:'sans-serif'}} > LEAVES </h6>
              <h3 className="value mb-0">{monthly_summary?.leave_days?? "-"}</h3>
            </div>
          </div>
        </Col>
        <Col>
          <div className="card d-flex d-flex-direction-row align-items-center"
          style={{ background: 'linear-gradient(135deg, #2a7a89 , #d1ecf1 )', padding: '16px', borderRadius: '8px',height: '100px',width: '100%' }}>
            <div className="d-flex d-flex-direction-column">
              <h6 style={{color: 'black', fontSize:"0.8125rem", fontFamily:'sans-serif'}} >OVER TIME HRS</h6>
              <h3 className="value mb-0">{monthly_summary?.overtime_hours?? "-"}</h3>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="calendar-container card mt-4 p-3">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <Button variant="outlined" onClick={handlePrevMonth}>
                &lt; Prev
              </Button>
              <h5 className="mb-0">{getMonthName(currentDate)}</h5>
              <Button variant="outlined" onClick={handleNextMonth}>
                Next &gt;
              </Button>
            </div>
            <div className="calendar-grid">
              {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
                <div className="calendar-header" key={day}>
                  {day}
                </div>
              ))}
              {Array(getFirstDayOfMonth(currentDate.getMonth(), currentDate.getFullYear()))
                .fill(null)
                .map((_, i) => (
                  <div key={`empty-${i}`} className="calendar-cell empty" />
                ))}
              {Array(daysInMonth(currentDate.getMonth(), currentDate.getFullYear()))
                  .fill(null)
                  .map((_, i) => {
                  const date = i + 1;
                  const fullDate = new Date(
                    currentDate.getFullYear(),
                    currentDate.getMonth(),
                    date
                  ).toLocaleDateString("en-CA"); // YYYY-MM-DD format without UTC shift
                 const status = statusMap[fullDate] || " ";
                 const legendClass = legendData.find((l) => l.code === status?.code)?.className || "unknown";
             return (
             <div key={date}
              className={`calendar-cell ${legendClass}`}
              onClick={() =>
                setSelectedDate(
                new Date(
                  currentDate.getFullYear(),
                  currentDate.getMonth(),
                  date
                )
              )
            }
             >
             <div className="date-number">{date}</div>
             <span className={`symbol ${legendClass}`}style={{ fontSize: '0.7rem' }}>{status?.code}</span>
             </div>
            );
           })}
          </div>
          </div>
        </Col>
        <Col>
        
        {(() => {
            const dateKey = selectedDate.toLocaleDateString("en-CA");
            const statusEntry = statusMap[dateKey];
            const isHoliday = statusEntry?.code === "H";

            if (isHoliday) {
              return (
                <Row>
                  <div className="header single-row"
                    style={{
                      background: "linear-gradient(135deg, #b8daff 0%, #e6f2ff 100%)", 
                      padding: "1rem",
                      borderRadius: "10px",
                      color: "#333",
                      transition: "background 0.3s ease"
                    }}
                  >
                    <h5>Holiday</h5>
                    <p>
                      {selectedDate.toLocaleDateString("en-US", {
                        weekday: "long",
                        month: "long",
                        day: "numeric",
                        year: "numeric",
                      })}
                    </p>
                    <p><strong>{statusEntry?.detail || "Holiday"}</strong></p>
                  </div>
                </Row>
              );
            }

            return (
              <>
                <Row>
                  <div className="header single-row">
                    <Row>
                      <Col xs={4}>
                        <div className="date-section">
                          <div className="date">
                            {selectedDate.getDate()}<br />
                            <span className="weekday">
                              {selectedDate.toLocaleString("en-us", { weekday: "short" })}
                            </span>
                          </div>
                        </div>
                      </Col>
                      <Col xs={4} className="text-center">
                        <div className="shift-section">
                          <div className="shift-title">General (GEN)</div>
                          <div className="timing">Shift: 09:00 to 18:00</div>
                        </div>
                      </Col>
                      <Col xs={4}>
                        <div className="scheme-section">
                          <div className="scheme">General</div>
                          <div className="scheme-type">Attendance Scheme</div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Row>
                <Row>
                  <div className="attendance-card"
                    style={{
                      background: statusGradients[statusEntry?.code] || statusGradients.default,
                      transition: "background 0.3s ease"
                    }}
                  >
                  {clockIn && <div className="processed-on">Processed on
                    {statusEntry?.code === "E" && (
                    <span className="early-logout-text"> <p> Early Logout </p></span>
                  )}
                  </div>}
                  {clockIn && <hr className="divider" />}
                    <Row>

                    {clockIn ? (
                        <>
                          <Col xs={6}>
                            <div className="clock-details">
                              Clock In: {formatTime(clockIn)}<br />
                              Clock Out: {clockOut ? formatTime(clockOut) : "-"}
                            </div>
                          </Col>
                          <Col xs={6}>
                            <div className="clock-details">
                              Regular Hours: {regularHours || "-"}<br />
                              Overtime Hours: {overtimeHours || "-"}
                            </div>
                          </Col>
                        </>
                      ) : (
                        <Col xs={12}>
                          <div className="clock-details text-center">
                            {statusEntry?.code === "A" && <strong> Your Absent</strong>}
                            {statusEntry?.code === "O" && <strong> It's Off Day</strong>}
                            {statusEntry?.code === "R" && <strong> It's Rest Day</strong>}
                            {statusEntry?.code === "L" && <strong> Your On Leave </strong>}
                            {!["A", "O", "R", "L"].includes(statusEntry?.code) && <strong>No attendance record</strong>}
                          </div>
                        </Col>
                      )}
                    </Row>
                  </div>
                </Row>
              </>
            );
          })()} 
        <Row>
        <div className="legend-container card p-3 mt-4">
            <h5 className="mb-3">Legends</h5>
            <div className="legend-grid">
              {legendData.map((item, index) => (
                <div className="legend-item" key={index}>
                  <span className={`legend-symbol ${item.className}`}>{item.code}</span>
                  <span className="legend-label">{item.label}</span>
                </div>
              ))}
            </div>
          </div>
          
        
         </Row>
        </Col>
      </Row>

    </div>
    
    </>
  );
};

export default TimeAttendance;




